var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var transformDealerStatusResponse = function (response, meta, arg) {
    var _a;
    var dealerCode = ((_a = arg.params) !== null && _a !== void 0 ? _a : {}).dealerCode;
    return __assign(__assign({}, response), { dealerCode: dealerCode });
};
export default transformDealerStatusResponse;
export function transformDealerAvailabilityResponse(response) {
    var res = {};
    response.forEach(function (_a) {
        var dealerCode = _a.dealerCode, inventoryAvailable = _a.inventoryAvailable;
        res[dealerCode] = inventoryAvailable;
    });
    return res;
}
